import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "../models/util.model";

@Injectable({
  providedIn: 'root'
})
export class SettlementService {
  private pathApi = this.config.setting['pathApi'] + "settlement/";
  private headers = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAll`, obj, { headers: this.headers, observe: 'response' }
    );
  }

  getSummary(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getSummary`, obj, { headers: this.headers, observe: 'response' }
    );
  }

  getDetailsById(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}details/${id}`, { headers: this.headers, observe: 'response' });
  }
}
